<div
  class="bg-primary-on box-border flex w-full text-base"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
  }">
  @let hasError = ngControl.errors && ngControl.touched;
  <div class="relative w-full bg-inherit">
    <input
      [attr.data-testid]="id() | appendTestId: 'input'"
      [formControl]="activeTextValue"
      [id]="id()"
      [placeholder]="label() ?? ''"
      [ngClass]="{
        'border-input-error! focus:border-input-focus': hasError,
        'border-input-ring focus:border-input-focus': !hasError,
      }"
      class="border-input-ring border-input peer p-input w-full rounded-lg bg-transparent placeholder-transparent focus:ring-0"
      type="text" />
    <label
      [attr.data-testid]="id() | appendTestId: 'label'"
      [for]="id()"
      [ngClass]="{
        'text-input-error': hasError,
      }"
      class="peer-placeholder-shown:text-input-label peer-focus:text-input-focus pointer-events-none absolute -top-3 left-0 mx-1 cursor-text bg-inherit px-1 text-sm transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-focus:-top-3 peer-focus:text-sm">
      {{ formattedLabel() }}
    </label>
    @if (hasError && !errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-content></ng-content>
      </aw-error-message>
    }
    @if (hasError && errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
      </aw-error-message>
    }
  </div>
</div>
